"use strict";
// packages/types/src/api/organisationProfile.ts
Object.defineProperty(exports, "__esModule", { value: true });
